//
// ImageScaleType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ImageScaleType = {
    NOSCALE:0,
    SCALETOFIT:1,
    SCALE:2,
    SCALEHEIGHT:3,
    SCALEWIDTH:4,
    TILE:5
};
export default ImageScaleType;
